import { supabasePlugin } from "@/plugins/supabase.ts";
import Exception from "@/utils/exception";

async function getDynamicReport(functionName, params) {
  try {
    const _res = await supabasePlugin.client.rpc(functionName, params);
    return _res;
  } catch (error) {
    Exception.catchException(error);
    throw error;
  }
}

export default {
  getDynamicReport
};
